export const NEW_MENU_ITEM = "NEW_MENU_ITEM";
export const ALL_MENU_ITEM = "ALL_MENU_ITEM";
export const UPDATE_MENU_ITEM = "UPDATE_MENU_ITEM";
export const DELETE_MENU_ITEM = "DELETE_MENU_ITEM";
export const MENU_ITEM_BY_VENDOR = "MENU_ITEM_BY_VENDOR";
export const MENU_ITEM_BY_SUBCAT = "MENU_ITEM_BY_SUBCAT";
export const MENU_ITEM_BY_CAT = "MENU_ITEM_BY_CAT";
export const UPLOAD_MENU_ITEM_IMG = "UPLOAD_MENU_ITEM_IMG";




